"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOVerifyEligibility = exports.IOVerifySS2Eligibility = exports.IOCreateOrSetPartnerAssociationCart = exports.IOCreateOrUpgradeCart = exports.getMatchingShippingPrice = exports.getMatchingShippingRate = exports.IOAddServicePlanToCart = exports.IOSetShippingMethod = exports.IORemoveDiscountCodeFromCart = exports.IOUpdateDiscountCodeToCart = exports.IOAddDiscountCodeToCart = exports.IOApplyDiscountCodeToCart = exports.IOSaveMySystem = exports.IOAddBmsToCart = exports.IORemoveFromCart = exports.IOUpdateQuantity = exports.IOUpdateCart = exports.IOAddDynamicPrebuiltToCart = exports.IOAddToCart = exports.IOGetCartByQuoteId = exports.IOGetCart = exports.IODeleteCart = exports.sortShippingMethodsAsc = exports.handleCartResponse = exports.updateCartWithProductTypes = exports.resetAndReplicateCart = exports.getShippingInfoKey = exports.LOCAL_STORAGE_CARTID = exports.clearCartError = exports.setCartError = exports.setCart = exports.setCartLoading = void 0;
const fromEmpty_1 = require("../utils/fromEmpty");
const safeFind_1 = require("../utils/safeFind");
const safeProp_1 = require("../utils/safeProp");
const fluture_1 = require("fluture");
const local_storage_1 = require("local-storage");
const monet_1 = require("monet");
const equals_1 = __importDefault(require("ramda/src/equals"));
const ifElse_1 = __importDefault(require("ramda/src/ifElse"));
const isEmpty_1 = __importDefault(require("ramda/src/isEmpty"));
const path_1 = __importDefault(require("ramda/src/path"));
const pathOr_1 = __importDefault(require("ramda/src/pathOr"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const propEq_1 = __importDefault(require("ramda/src/propEq"));
const propOr_1 = __importDefault(require("ramda/src/propOr"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const sortBy_1 = __importDefault(require("ramda/src/sortBy"));
const cart_1 = require("../commercetools/cart");
const price_1 = require("../commercetools/price");
const select_1 = require("../redux/select");
const errorLogging_1 = require("../thirdparty/errorLogging");
const errorHandler_1 = require("./errorHandler");
const setCartLoading = (isLoading) => ({
    '@@type': 'cart',
    payload: isLoading,
    type: 'SET_CART_LOADING'
});
exports.setCartLoading = setCartLoading;
const setCart = (cart) => ({
    '@@type': 'cart',
    payload: cart,
    type: 'SET_CART'
});
exports.setCart = setCart;
const setCartError = (error) => ({
    '@@type': 'cart',
    payload: monet_1.Maybe.fromUndefined(error),
    type: 'SET_CART_ERROR'
});
exports.setCartError = setCartError;
/**
 *
 */
const clearCartError = () => ({
    '@@type': 'cart',
    type: 'CLEAR_CART_ERROR'
});
exports.clearCartError = clearCartError;
exports.LOCAL_STORAGE_CARTID = 'cartId';
const getShippingInfoKey = (cartId) => `shipinfo-${cartId}`;
exports.getShippingInfoKey = getShippingInfoKey;
// export for unit testing
const resetAndReplicateCart = () => {
    const cartId = (0, local_storage_1.get)(exports.LOCAL_STORAGE_CARTID);
    return (0, cart_1.commercetoolsReplicateCart)(cartId)
        .pipe((0, fluture_1.map)(res => {
        (0, local_storage_1.remove)(exports.LOCAL_STORAGE_CARTID);
        (0, local_storage_1.remove)((0, exports.getShippingInfoKey)(cartId));
        res.forEach(cart => (0, local_storage_1.set)(exports.LOCAL_STORAGE_CARTID, cart.id));
        return res;
    }));
};
exports.resetAndReplicateCart = resetAndReplicateCart;
const updateCartWithProductTypes = (state) => (cart) => {
    const lineItems = cart.get('lineItems')
        .map(lineItem => {
        const sku = (0, prop_1.default)('sku', lineItem);
        const product = (0, select_1.selectProduct)(sku)(state);
        const productType = product.toMaybe().chain(p => monet_1.Maybe.fromNull(p.productType));
        return {
            ...lineItem,
            productType: lineItem.productType || productType.orUndefined()
        };
    });
    return cart.set('lineItems', lineItems);
};
exports.updateCartWithProductTypes = updateCartWithProductTypes;
const handleCartResponse = (future, handleFailure, handleSuccess) => (dispatch, getState) => future
    .pipe((0, fluture_1.chainRej)(errorHandler_1.cartErrorHandler))
    .pipe((0, fluture_1.fork)((err) => {
    dispatch((0, exports.setCartLoading)(false));
    dispatch((0, exports.setCartError)(err));
    handleFailure && handleFailure(err);
})(cart => {
    dispatch((0, exports.setCartLoading)(false));
    cart.forEach(_cart => {
        // No cart operations can be performed on Merged or Ordered carts
        // https://docs.commercetools.com/api/projects/carts#cartstate
        const isActive = _cart.cartState === 'Active';
        monet_1.Maybe.fromFalsy(isActive).cata(() => {
            // Reset cart in redux & remove relevant data from local storage if the cart isn't active
            dispatch((0, exports.setCart)((0, monet_1.None)()));
            (0, local_storage_1.remove)(exports.LOCAL_STORAGE_CARTID);
            (0, local_storage_1.remove)((0, exports.getShippingInfoKey)(_cart.id));
        }, () => {
            const newCart = cart
                .map(cart_1.CTCartToRecord)
                .map((0, exports.updateCartWithProductTypes)(getState()));
            dispatch((0, exports.setCart)(newCart));
            (0, local_storage_1.set)(exports.LOCAL_STORAGE_CARTID, _cart.id);
        });
        handleSuccess && handleSuccess(_cart);
    });
}));
exports.handleCartResponse = handleCartResponse;
const sortOrderPath = (val) => (0, pathOr_1.default)(0, ['custom', 'fields', 'sortOrder'], val);
exports.sortShippingMethodsAsc = (0, sortBy_1.default)(sortOrderPath);
/**
 * Delete a cart by ID.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   dispatch(IODeleteCart(handleFailure?, handleSuccess?))
 * }, [ dispatch ])
 */
const IODeleteCart = (handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const deleteCart = (cartId) => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsDeleteCart)(cartId), e => {
            (0, errorLogging_1.logError)(e, { cartAction: 'IODeleteCart' });
            handleFailure && handleFailure();
        }, () => {
            handleSuccess && handleSuccess();
        }));
    };
    cart.cata(() => undefined, () => undefined, () => undefined, cart => deleteCart(cart.id));
};
exports.IODeleteCart = IODeleteCart;
/**
 * Get a cart by ID.
 *
 * It will use an ID if provided, otherwise it will try and load one from local storage.
 * This should be used at the page level so we can populate the cart icon with the number of items in the cart.
 * If there is no id provided and there is no id in local storage this does nothing.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   dispatch(IOGetCart(id?, handleFailure?, handleSuccess?))
 * }, [ dispatch ])
 */
const IOGetCart = (id, handleFailure, handleSuccess) => (dispatch) => {
    monet_1.Maybe.fromNull(id || (0, local_storage_1.get)(exports.LOCAL_STORAGE_CARTID))
        .forEach(i => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsGetCart)(i), e => {
            (0, errorLogging_1.logError)(e, { cartAction: 'IOGetCart' });
            handleFailure && handleFailure();
        }, () => handleSuccess && handleSuccess()));
    });
};
exports.IOGetCart = IOGetCart;
const IOGetCartByQuoteId = (id, emailHash, handleFailure, handleSuccess) => (dispatch) => {
    dispatch((0, exports.setCartLoading)(true));
    dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsGetCartByQuoteId)(id, emailHash), e => {
        (0, errorLogging_1.logError)(e, { cartAction: 'IOGetCartByQuoteId' });
        handleFailure && handleFailure();
    }, () => {
        handleSuccess && handleSuccess();
    }));
};
exports.IOGetCartByQuoteId = IOGetCartByQuoteId;
/**
 * Add items to a cart. If a cart does not exist, one will be created. If a cart is already loading, this does nothing.
 *
 * @example
 * const [ body, setBody ] = useState({})
 * const dispatch = useDispatch()
 *
 * const addToCart = useCallback(() => {
 *   dispatch(IOAddToCart(body, handleFailure?, handleSuccess?))
 * }, [ dispatch, body ]
 */
const IOAddToCart = (body, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const locale = (0, select_1.selectLocale)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    // Applying valid discount code automatically during the cart creation.
    // TODO figure out cart promo code addition
    // const discountCode =
    //   cartId.catchMap(() => Maybe.fromFalsy(selectPromotion('promoCode')(getState())))
    const addToCart = () => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsAddToCart)(cartId.orUndefined(), variationId)({
            // discountCode: discountCode.orUndefined(),
            locale,
            ...body
        }), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOAddToCart',
                cartActionDetails: monet_1.Maybe.fromNull(body.discountCode)
                    .map(() => 'addDiscountCode')
                    .toArray()
                    .concat((0, fromEmpty_1.fromEmpty)(body.products)
                    .map(() => ['addProducts'])
                    .orJust([]))
                    .join(',')
            });
            handleFailure && handleFailure();
        }, (_cart) => {
            handleSuccess && handleSuccess((0, cart_1.CTCartToRecord)(_cart));
        }));
    };
    cart.cata(() => undefined, // don't do anything if cart is loading
    addToCart, addToCart, addToCart);
};
exports.IOAddToCart = IOAddToCart;
/**
 * Adds BMS to cart with additional products as seperate line items
 *
 * @example
 * const dynamicPrebuilt = prebuiltPackage(sku)
 * const dispatch = useDispatch()
 *
 * const addToCart = useCallback(() => {
 *   dispatch(IOAddDynamicPrebuiltToCart(
 *      dynamicPrebuilt,
 *      {
 *        discountCode: 'SIMPLIREFURB50',
 *        products: [{ 4, SSESSKU}]
 *      },
 *      handleFailure?,
 *      handleSuccess?))
 * }, [ dispatch, dynamicPrebuilt ]
 */
const IOAddDynamicPrebuiltToCart = (body, additionalProducts, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const locale = (0, select_1.selectLocale)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    const addToCart = () => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsAddBmsToCart)(cartId.orUndefined(), variationId)({
            locale,
            ...body
        }), e => {
            (0, errorLogging_1.logError)(e, { cartAction: 'IOAddBmsToCart' });
            handleFailure && handleFailure();
        }, (_cart) => {
            additionalProducts?.products?.length && dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsAddToCart)(_cart.id, variationId)({
                // discountCode: discountCode.orUndefined(),
                locale,
                ...additionalProducts
            }), error => {
                (0, errorLogging_1.logError)(error, {
                    cartAction: 'IOAddToCart',
                    cartActionDetails: monet_1.Maybe.fromNull(body.discountCode)
                        .map(() => 'addDiscountCode')
                        .toArray()
                        .concat((0, fromEmpty_1.fromEmpty)(body.products)
                        .map(() => ['addProducts'])
                        .orJust([]))
                        .join(',')
                });
                handleFailure && handleFailure();
            }, (_cart) => {
                handleSuccess && handleSuccess((0, cart_1.CTCartToRecord)(_cart));
            }));
            !additionalProducts?.products?.length && handleSuccess && handleSuccess((0, cart_1.CTCartToRecord)(_cart));
        }));
    };
    cart.cata(() => undefined, // don't do anything if cart is loading
    addToCart, addToCart, addToCart);
};
exports.IOAddDynamicPrebuiltToCart = IOAddDynamicPrebuiltToCart;
/**
 * Update a cart using CT Update Actions. Does nothing if a cart is already
 * loading or if a cart does not exist.
 *
 * {@link https://docs.commercetools.com/api/projects/carts#update-actions Update Actions docs}
 *
 *
 * @example
 * const [ address, setAddress ] = useState({})
 * const dispatch = useDispatch()
 *
 * const updateCartAddress = useCallback(() => {
 *  dispatch(IOUpdateCart([
 *     { action: 'setShippingAddress', address }
 *  ], handleFailure?, handleSuccess?))
 * }, [ dispatch, address ]
 */
const IOUpdateCart = (actions, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    const updateCart = (cartId) => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsUpdateCart)(cartId, variationId)(actions), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOUpdateCart',
                cartActionDetails: actions.map(a => a.action).join(',')
            });
            handleFailure && handleFailure();
        }, (_cart) => {
            handleSuccess && handleSuccess((0, cart_1.CTCartToRecord)(_cart));
        }));
    };
    actions.length > 0 && cart.cata(() => undefined, // don't do anything if cart is loading
    // if cart is in error, only update it if we have a cart
    () => cartId.forEach(_cartId => updateCart(_cartId)), () => undefined, // don't do anything if we don't have a cart
    // don't do anything if we don't have a cart
    cart => updateCart(cart.id));
};
exports.IOUpdateCart = IOUpdateCart;
/**
 * Updates the quantity for a line item in the cart. Does nothing if a cart is already
 * loading or if a cart does not exist.
 *
 * @example
 * const [ lineItemId, setLineItemId ] = useState('')
 * const [ quantity, setQuantity ] = useState(0)
 * const dispatch = useDispatch()
 *
 * const updateQuantity = useCallback(() => {
 *  dispatch(IOUpdateQuantity(lineItemId, quantity, handleFailure?, handleSuccess?))
 * }, [ dispatch, lineItemId, quantity ]
 */
const IOUpdateQuantity = (lineItemId, quantity, handleFailure, handleSuccess) => (dispatch, getState) => {
    dispatch((0, exports.IOUpdateCart)([{
            action: 'updateCart',
            locale: (0, select_1.selectLocale)(getState()),
            products: [{
                    lineItemId,
                    quantity
                }]
        }], handleFailure, handleSuccess));
};
exports.IOUpdateQuantity = IOUpdateQuantity;
// TODO: split up cart functions into seperate files
// /cart
// --/create
// --/update
// etc
/**
 * Removes a line item from the cart. Does nothing if a cart is already
 * loading or if a cart does not exist.
 *
 * @example
 * const [ lineItemId, setLineItemId ] = useState('')
 * const dispatch = useDispatch()
 *
 * const removeFromCart = useCallback(() => {
 *  dispatch(IORemoveFromCart(lineItemId, handleFailure?, handleSuccess?))
 * }, [ dispatch, lineItemId ]
 */
const IORemoveFromCart = (lineItemId, handleFailure, handleSuccess) => (dispatch) => {
    dispatch((0, exports.IOUpdateCart)([{
            action: 'removeLineItem',
            products: [{ lineItemId }]
        }], handleFailure, handleSuccess));
};
exports.IORemoveFromCart = IORemoveFromCart;
/**
 * Add items to a BMS cart. If a cart does not exist, one will be created. If a cart is already loading, this does nothing.
 *
 * @example
 * const [ body, setBody ] = useState({})
 * const dispatch = useDispatch()
 *
 * const addBmsToCart = useCallback(() => {
 *   dispatch(IOAddBmsToCart(body, handleFailure?, handleSuccess?))
 * }, [ dispatch, body ]
 */
const IOAddBmsToCart = (body, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const locale = (0, select_1.selectLocale)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    const addBmsToCart = () => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsAddBmsToCart)(cartId.orUndefined(), variationId)({
            locale,
            ...body
        }), e => {
            (0, errorLogging_1.logError)(e, { cartAction: 'IOAddBmsToCart' });
            handleFailure && handleFailure();
        }, (_cart) => {
            handleSuccess && handleSuccess((0, cart_1.CTCartToRecord)(_cart));
        }));
    };
    cart.cata(() => undefined, // don't do anything if cart is loading
    addBmsToCart, addBmsToCart, addBmsToCart);
};
exports.IOAddBmsToCart = IOAddBmsToCart;
/**
 * Add items to a SMS cart. If a cart does not exist, one will be created. If the cart is already loading, this does nothing.
 *
 * @example
 * const [ body, setBody ] = useState({})
 * const dispatch = useDispatch()
 *
 * const saveMySystem = useCallback(() => {
 *   dispatch(IOSaveMySystem(body, handleFailure?, handleSuccess?))
 * }, [ dispatch, body ]
 */
const IOSaveMySystem = (body, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const locale = (0, select_1.selectLocale)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    const handleError = (err) => {
        dispatch((0, exports.setCartLoading)(false));
        dispatch((0, exports.setCartError)(err));
        (0, errorLogging_1.logError)(err, { cartAction: 'IOSaveMySystem' });
        handleFailure && handleFailure();
    };
    // Instead of calling handleCartResponse, we don't want the success state to affect the current redux cart
    // since all this is doing is saving the BMS configuration into an email for later retrieval.
    const handleSMSResponse = (future) => (dispatch) => future.pipe((0, fluture_1.fork)(handleError)(() => {
        dispatch((0, exports.setCartLoading)(false));
        handleSuccess && handleSuccess();
    }));
    const saveMySystem = () => {
        dispatch((0, exports.setCartLoading)(true));
        dispatch(handleSMSResponse((0, cart_1.commercetoolsSaveMySystem)(cartId.orUndefined(), variationId)({
            locale,
            package: {
                quantity: 1,
                sku: `simplisafe-custom-home-security-system-${locale}`
            },
            ...body
        })));
    };
    cart.cata(() => undefined, handleError, saveMySystem, saveMySystem);
};
exports.IOSaveMySystem = IOSaveMySystem;
/**
 * Apply a coupon to a cart. If a cart does not exist, one will be created. If the cart is already loading, this does nothing.
 *
 * @example
 * const [ discountCode, setDiscountCode ] = useState('')
 * const dispatch = useDispatch()
 *
 * const applyDiscount = useCallback(() => {
 *   dispatch(IOApplyDiscountCodeToCart(discountCode, handleFailure?, handleSuccess?))
 * }, [ dispatch, discountCode ]
 */
const IOApplyDiscountCodeToCart = (discountCode, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cartId = (0, select_1.selectCartId)(getState());
    cartId.cata(
    // Create a cart with a discount code if we don't have a cart already
    () => dispatch((0, exports.IOAddToCart)({
        discountCode,
        products: []
    }, handleFailure, handleSuccess)), 
    // Otherwise, update the existing cart with the discount code
    _ => dispatch((0, exports.IOUpdateCart)([{
            action: 'addDiscountCode',
            code: discountCode
        }], handleFailure, handleSuccess)));
};
exports.IOApplyDiscountCodeToCart = IOApplyDiscountCodeToCart;
/**
 * Adding multiple discount codes to the existing cart.
 *
 * @example
 * const [ discountCodes, setDiscountCodes ] = useState(['CODE1', 'CODE2'])
 * const dispatch = useDispatch()
 *
 * const applyDiscount = useCallback(() => {
 *   dispatch(IOAddDiscountCodeToCart(discountCodes, handleFailure?, handleSuccess?))
 * }, [ dispatch, discountCode ]
 */
const IOAddDiscountCodeToCart = (discountCodes, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cartId = (0, select_1.selectCartId)(getState());
    cartId.isJust() && dispatch((0, exports.IOUpdateCart)((0, reduce_1.default)((acc, discountCode) => {
        const action = {
            action: 'addDiscountCode',
            code: discountCode
        };
        return [...acc, action];
    }, [])(discountCodes), handleFailure, handleSuccess));
};
exports.IOAddDiscountCodeToCart = IOAddDiscountCodeToCart;
/**
 * Updating multiple discount codes or single code to the existing cart buy overriding all the exiting discounts
 * available in the cart.
 *
 * @example
 * const [ discountCodes, setDiscountCodes ] = useState(['CODE1', 'CODE2'])
 * const dispatch = useDispatch()
 *
 * const applyDiscount = useCallback(() => {
 *   dispatch(IOUpdateDiscountCodeToCart(discountCodes, handleFailure?, handleSuccess?))
 * }, [ dispatch, discountCodes ]
 */
const IOUpdateDiscountCodeToCart = (discountCodes, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cartId = (0, select_1.selectCartId)(getState());
    cartId.isJust() && dispatch((0, exports.IOUpdateCart)((0, reduce_1.default)((acc, discountCode) => {
        const action = {
            action: 'addManualDiscountCode',
            code: discountCode
        };
        return [...acc, action];
    }, [])(discountCodes), handleFailure, handleSuccess));
};
exports.IOUpdateDiscountCodeToCart = IOUpdateDiscountCodeToCart;
/**
 * Removing multiple non matched/appied or all discount codes from the existing cart. This can be used
 * to have clean cart during checkout process.
 *
 * @example
 *
 * To remove the not applied discounts from the cart.
 *
 * dispatch(IORemoveDiscountCodeFromCart())
 *
 * To remove all the discounts from the cart.
 *
 * dispatch(IORemoveDiscountCodeFromCart(true, handleFailure?, handleSuccess?))
 */
const IORemoveDiscountCodeFromCart = (isRemoveAll = false, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cart = (0, select_1.selectCart)(getState());
    cart.cata(() => undefined, // No action when cart is loading
    () => undefined, // No action when cart is error
    () => undefined, // No action when cart is empty
    // No action when cart is empty
    _cart => {
        const discountCodes = ((0, prop_1.default)('discountCodes', _cart)).getOrElse([]);
        dispatch((0, exports.IOUpdateCart)((0, reduce_1.default)((acc, discountCodeInfo) => {
            const action = {
                action: 'removeDiscountCode',
                discountCode: (0, prop_1.default)('discountCode', discountCodeInfo)
            };
            return !isRemoveAll && (0, propEq_1.default)('state', 'MatchesCart', discountCodeInfo) ? acc : [...acc, action];
        }, [])(discountCodes), handleFailure, handleSuccess));
    });
};
exports.IORemoveDiscountCodeFromCart = IORemoveDiscountCodeFromCart;
/**
 * Set shipping method to the cart. Does nothing if a cart is already
 * loading or if a cart does not exist.
 *
 * @example
 * const [ shippingMethodId, setShippingMethodId ] = useState('')
 * const dispatch = useDispatch()
 *
 * const setShippingMethod = useCallback(() => {
 *  dispatch(IOSetShippingMethod(shippingMethodId, handleFailure?, handleSuccess?))
 * }, [ dispatch, shippingMethodId ]
 */
const IOSetShippingMethod = (shippingMethodId, handleFailure, handleSuccess) => (dispatch) => {
    dispatch((0, exports.IOUpdateCart)([{
            action: 'setShippingMethod',
            shippingMethod: {
                id: shippingMethodId,
                typeId: 'shipping-method'
            }
        }], handleFailure, handleSuccess));
};
exports.IOSetShippingMethod = IOSetShippingMethod;
/**
 * Adding porduct service plan to the existing cart.
 *
 * @example
 * dispatch(IOAddServicePlanToCart([AddServicePlanBody], handleFailure?, handleSuccess?))
 */
const IOAddServicePlanToCart = (servicePlans, handleFailure, handleSuccess) => (dispatch, getState) => {
    const cartId = (0, select_1.selectCartId)(getState());
    cartId.isJust() && dispatch((0, exports.IOUpdateCart)((0, reduce_1.default)((acc, servicePlan) => {
        const action = {
            ...servicePlan,
            action: 'addServicePlan'
        };
        return [...acc, action];
    }, [])(servicePlans), handleFailure, handleSuccess));
};
exports.IOAddServicePlanToCart = IOAddServicePlanToCart;
const getMatchingShippingRate = (shippingMethod) => (0, safeProp_1.safeProp)('zoneRates', shippingMethod)
    .chain((0, safeFind_1.safeFind)(zoneRates => zoneRates.shippingRates.some((0, propEq_1.default)('isMatching', true))))
    .chain((0, safeProp_1.safeProp)('shippingRates'))
    .chain((0, safeFind_1.safeFind)(s => !!s.isMatching));
exports.getMatchingShippingRate = getMatchingShippingRate;
/**
 * transforms the string we receive from priceFunction that commercetools provides in the shipping * rate tiers into an executable function so that we can calculate shipping method price. We
 * replace x in the commercetools function with the score we receive from shipping rate input and
 * execute the new function to get the shipping method price.
 *
 */
const getMatchingShippingPrice = (shipRate, cart) => shipRate
    .chain((0, safeProp_1.safeProp)('tiers'))
    .chain((0, safeFind_1.safeFind)(tier => {
    const isPriceFunction = !(0, isEmpty_1.default)((0, path_1.default)(['priceFunction', 'function'], tier));
    return tier.isMatching === true && isPriceFunction;
}))
    .map((tier) => {
    const priceFunction = (0, pathOr_1.default)('', ['priceFunction', 'function'], tier);
    /**
     * we need to grab the shipping rate input (score)
     * so that the function we receive from priceFunction can execute.
     * see https://docs.commercetools.com/api/projects/shippingMethods#pricefunction
     */
    const shippingRateInput = (0, propOr_1.default)(0, 'shippingRateInput', cart);
    const formattedStringFunction = priceFunction.replace('x', String(shippingRateInput));
    // eslint-disable-next-line
    const calculatedScore = new Function('return (' + formattedStringFunction + ')/100')();
    return calculatedScore;
})
    .orElse(shipRate.chain((0, safeProp_1.safeProp)('price')).map(price_1.formatCTPriceToNumber));
exports.getMatchingShippingPrice = getMatchingShippingPrice;
/**
 * Creates or updates a cart to an upgrade cart, used mainly for the SS2 upgrade flow.
 * Upon cart creation, the userId is used by the backend to determine if the user is eligible for a discount.
 *
 * @example
 * const [ userId, setUserId ] = useState('')
 * const dispatch = useDispatch()
 *
 * dispatch(IOCreateOrUpgradeCart(userId, handleFailure?, handleSuccess?))
 */
const IOCreateOrUpgradeCart = (userId, customerGroup, handleFailure, handleSuccess) => (dispatch, getState) => {
    const locale = (0, select_1.selectLocale)(getState());
    const cartId = (0, select_1.selectCartId)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    dispatch((0, exports.setCartLoading)(true));
    cartId.cata(() => {
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsCreateUpgradeCart)(userId, locale, variationId), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOCreateOrUpgradeCart',
                cartActionDetails: 'commercetoolsCreateUpgradeCart'
            });
            handleFailure && handleFailure(e);
        }, () => handleSuccess && handleSuccess()));
    }, (_cartId) => {
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsSetCustomerGroup)(userId, _cartId, customerGroup, variationId), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOCreateOrUpgradeCart',
                cartActionDetails: 'commercetoolsSetCustomerGroup'
            });
            handleFailure && handleFailure(e);
        }, () => handleSuccess && handleSuccess()));
    });
};
exports.IOCreateOrUpgradeCart = IOCreateOrUpgradeCart;
/**
 * Creates or updates a cart by setting a partner association which adds a customer group to the cart and a custom field for partner name. Partner associations are set on partner landing pages.
 * On cart creation, the customerGroup and partnerName values that are currently being stored in the partner page content type are passed to the the backend to determine if the user is eligible for a partner offer.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * dispatch(IOCreateOrUpgradeCart(customerGroup, partnerName, handleFailure?, handleSuccess?))
 */
const IOCreateOrSetPartnerAssociationCart = (customerGroupKey, partnerName, cartId, handleFailure, handleSuccess) => (dispatch, getState) => {
    const locale = (0, select_1.selectLocale)(getState());
    const variationId = (0, select_1.selectCurrentPromoVariationId)(getState());
    dispatch((0, exports.setCartLoading)(true));
    (0, ifElse_1.default)((0, equals_1.default)(''), () => {
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsCreatePartnerAssociationCart)(customerGroupKey, partnerName, locale, variationId), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOCreateOrSetPartnerAssociationCart',
                cartActionDetails: 'commercetoolsCreatePartnerAssociationCart'
            });
            handleFailure && handleFailure(e);
        }, () => handleSuccess && handleSuccess()));
    }, () => {
        dispatch((0, exports.handleCartResponse)((0, cart_1.commercetoolsSetPartnerAssociation)(customerGroupKey, partnerName, cartId, variationId), e => {
            (0, errorLogging_1.logError)(e, {
                cartAction: 'IOCreateOrSetPartnerAssociationCart',
                cartActionDetails: 'commercetoolsSetPartnerAssociation'
            });
            handleFailure && handleFailure(e);
        }, () => handleSuccess && handleSuccess()));
    })(cartId);
};
exports.IOCreateOrSetPartnerAssociationCart = IOCreateOrSetPartnerAssociationCart;
const eligibleBodySuccess = (handleFailure, handleSuccess) => (eligible) => {
    eligible.cata(() => handleFailure(new Error('Response body is None')), ({ eligible }) => eligible ? handleSuccess && handleSuccess() : handleFailure(new Error('User is not eligible')));
};
// TODO: Should probably moved to a different location since it isn't Redux-related
const IOVerifySS2Eligibility = (userId, handleFailure, handleSuccess) => {
    const failureState = (err) => {
        (0, errorLogging_1.logError)(err, { cartAction: 'IOVerifySS2Eligibility' });
        handleFailure && handleFailure(err);
    };
    (0, cart_1.commercetoolsVerifySS2Eligibility)(userId).pipe((0, fluture_1.fork)((err) => failureState(err))(eligibleBodySuccess(failureState, handleSuccess)));
};
exports.IOVerifySS2Eligibility = IOVerifySS2Eligibility;
/**
     * Verify that a given user is eligible for the supplied customer group.
     *
     * @example
     * const [ userId, setUserId ] = useState('')
     * const dispatch = useDispatch()
     *
     * dispatch(IOVerifyEligibility(userId, 'interactiveCustomers-US', handleFailure?, handleSuccess?))
     */
const IOVerifyEligibility = (userId, customerGroup, handleFailure, handleSuccess) => {
    const failureState = (err) => {
        (0, errorLogging_1.logError)(err, { cartAction: 'IOVerifyEligibility' });
        handleFailure && handleFailure(err);
    };
    (0, cart_1.commercetoolsVerifyEligibility)(userId, customerGroup).pipe((0, fluture_1.fork)((err) => failureState(err))(eligibleBodySuccess(failureState, handleSuccess)));
};
exports.IOVerifyEligibility = IOVerifyEligibility;
//# sourceMappingURL=actions.js.map